import Segment from '@getaccept/lib-shared/src/segment';
import { AnalyticsUserTrait } from '@getaccept/lib-shared/src/types/analytics';
import Analytics from '@getaccept/lib-shared/src/analytics';
import type { Language } from '@getaccept/lib-shared/src/languages/enums/language';

export const initializeAnalytics = (userId: string, language: Language) => () => {
  Segment.page('Signup');

  if (!userId) {
    return;
  }

  Analytics.identify(userId, {
    [AnalyticsUserTrait.Language]: language,
  });
};
